module.exports = __webpack_public_path__ + "static/img/p6.550a2f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/importMp3/p6.png
// module id = i4z9
// module chunks = 0